import { toArdoqError } from '@ardoq/common-helpers';
import { type I18nLocale, t } from '@ardoq/i18n';
import { Box, FlexBox } from '@ardoq/layout';
import { ErrorState } from '@ardoq/status-ui';

type WidgetErrorBodyProps = {
  errors: string[];
  i18nLocale: I18nLocale;
};

export const WidgetErrorBody = ({
  errors,
  i18nLocale,
}: WidgetErrorBodyProps) => (
  <FlexBox width="full" height="full" padding="medium" overflow="auto">
    <Box margin="auto">
      <ErrorState
        size="small"
        title={t(
          i18nLocale,
          'dashboard:widgetErrorBody.title',
          "This widget can't be displayed"
        )}
        error={toArdoqError({
          error: new Error('Dashboard widget error'),
          userMessage: errors.join(' '),
        })}
      />
    </Box>
  </FlexBox>
);
